import { isValidPhoneNumber } from 'react-phone-number-input';

const PHONE_FIELD_KEYS = new Set(['phoneNo', 'phone_no']);

function digitCount(value: string): number {
    return value.replace(/\D/g, '').length;
}

/** True for empty, country-code-only (`+234`), or otherwise incomplete numbers. */
export function isIncompletePhoneNumber(value: unknown): boolean {
    if (value == null) return true;
    const text = String(value).trim();
    if (!text) return true;
    return !isValidPhoneNumber(text);
}

/**
 * Drop blank and country-code-only values so they are not sent to the API.
 * Keep other strings so schema validation can reject a partial number.
 */
export function normalizeOptionalPhone(value: unknown): string | undefined {
    if (value == null) return undefined;
    const text = String(value).trim();
    if (!text) return undefined;
    if (isValidPhoneNumber(text)) return text;
    if (digitCount(text) <= 3) return undefined;
    return text;
}

export function isPhoneFieldKey(key: string): boolean {
    return PHONE_FIELD_KEYS.has(key);
}
